// Mock data for Dr. Hardik Barot personal website
// All data derived from his official profile (Mar 2025)

export const profile = {
  name: "Dr. Hardik Barot",
  shortName: "Dr. Hardik",
  initials: "HB",
  tagline: "Hospital Management Consultant & NABH Accreditation Expert",
  positioning:
    "Driving healthcare excellence through quality, accreditation and management consulting — across 200+ hospitals in India.",
  headline:
    "Driving healthcare\nexcellence through\nquality management.",
  subheadline:
    "Founder of DianaMik Hospital Management Consultancy. Helping hospitals plan, build, accredit and grow with measurable outcomes since 2018.",
  photo: "/images/dr-hardik-barot.png",
  location: "Ahmedabad, Gujarat, India",
  yearsActive: "15+",
  founded: "2018",
  contact: {
    phone: "+91 84604 49124",
    email: "info@dianamik.com",
    website: "www.dianamik.com",
    address:
      "4th Floor, 9/A, Nakshatra Arcade, IOC Road, Nr. Sneh Plaza, Chandkheda, Ahmedabad, Gujarat"
  },
  social: {
    linkedin: "#",
    twitter: "#",
    website: "https://www.dianamik.com"
  }
};

export const stats = [
  { value: "200+", label: "Hospitals Served" },
  { value: "150+", label: "NABH Accreditations" },
  { value: "50+", label: "TPA Empanelments" },
  { value: "25+", label: "Planning & Design Projects" }
];

export const about = {
  title: "About Dr. Barot",
  paragraphs: [
    "A young, enthusiastic healthcare leader with a rare blend of clinical, administrative and legal expertise — Dr. Hardik Barot has spent the last decade transforming how Indian hospitals approach quality, accreditation and operational excellence.",
    "Trained as a physiotherapist, formally educated in Hospital Management, and a qualified law graduate (LL.B.), Dr. Barot founded DianaMik Hospital Management Consultancy in 2018 with one mission — to deliver authentic, measurable hospital quality improvement to institutions of every size.",
    "Today, his consultancy works with a curated network of doctors and quality professionals serving 200+ hospitals across Gujarat — covering Allopathic, Ayurvedic, Panchkarma facilities and Imaging Centres."
  ],
  highlights: [
    "Masters of Hospital Management — HNGU",
    "Bachelor of Physiotherapy — MSU Baroda",
    "LL.B. — HNGU",
    "Certified VMove Pro — Global Public Health"
  ]
};

export const expertise = [
  {
    title: "NABH Accreditation",
    description:
      "Full & entry-level NABH for hospitals, Ayush facilities and imaging centres — gap assessment to certification.",
    icon: "ShieldCheck"
  },
  {
    title: "NABL Accreditation",
    description:
      "Laboratory quality management, technical competence assessment and ISO 15189-aligned documentation.",
    icon: "Microscope"
  },
  {
    title: "Hospital Planning & Design",
    description:
      "Greenfield hospital projects, layout optimisation, NABH-compliant zoning and turnkey delivery.",
    icon: "Building2"
  },
  {
    title: "TPA & Cashless",
    description:
      "TPA tie-ups, empanelment, cashless file processing and revenue cycle optimisation for hospitals.",
    icon: "FileCheck2"
  },
  {
    title: "PMJAY & Govt. Schemes",
    description:
      "Ayushman Bharat (PMJAY) empanelment, MAA Yojna tie-ups and ongoing scheme processing support.",
    icon: "Landmark"
  },
  {
    title: "Medico-Legal Consulting",
    description:
      "Healthcare compliance, consent frameworks, medical negligence advisory and legal risk audit.",
    icon: "Scale"
  },
  {
    title: "Quality Management",
    description:
      "KPIs, clinical audits, MRD compliance, infection control and continuous improvement programs.",
    icon: "BarChart3"
  },
  {
    title: "Physiotherapy",
    description:
      "Clinical roots in physiotherapy — community service, sport rehabilitation and patient-first care.",
    icon: "Activity"
  }
];

export const services = [
  {
    title: "NABH Accreditation & Certification",
    blurb:
      "End-to-end NABH preparation — from gap analysis and SOPs to mock audit and final assessment. 150+ hospitals certified.",
    deliverables: ["Gap assessment", "SOP & policy library", "Staff training", "Mock audits", "Assessment hand-holding"]
  },
  {
    title: "NABL Accreditation",
    blurb:
      "Laboratory accreditation under ISO 15189 — quality manual, technical records and competence demonstration.",
    deliverables: ["Quality manual", "SOPs & records", "Internal audits", "PT participation strategy"]
  },
  {
    title: "Hospital Planning & Designing",
    blurb:
      "Architecturally efficient and accreditation-ready hospitals. 25+ planning & design projects completed.",
    deliverables: ["Functional brief", "Zoning & flow", "Equipment planning", "NABH-aligned layouts"]
  },
  {
    title: "Hospital TPA Tie-ups & Cashless",
    blurb:
      "TPA empanelment, network expansion and cashless file processing to unlock new revenue streams.",
    deliverables: ["Empanelment", "Tariff structuring", "Cashless processing", "Denials management"]
  },
  {
    title: "PMJAY Tie-up & Processing",
    blurb:
      "Ayushman Bharat PMJAY empanelment and ongoing claim processing — 10+ hospitals empanelled.",
    deliverables: ["Empanelment files", "Pre-auth", "Claim submission", "Audit defence"]
  },
  {
    title: "Medico-Legal Consulting",
    blurb:
      "Launched April 2024 — protecting hospitals & doctors with compliance, documentation and legal advisory.",
    deliverables: ["Consent frameworks", "MRD review", "Negligence advisory", "Compliance audit"]
  }
];

export const experience = [
  {
    role: "Founder & Lead Consultant",
    org: "DianaMik Hospital Management Consultancy",
    period: "Aug 2018 — Present",
    description:
      "Founded a full-service hospital quality consultancy. Led 150+ NABH accreditations, 25+ hospital planning projects and 50+ TPA empanelments. Launched medico-legal consulting vertical in 2024."
  },
  {
    role: "Chief Hospital Administrator",
    org: "SAVA Multispeciality Hospital, Surendranagar",
    period: "Pre-2018",
    description:
      "Led day-to-day hospital administration, operational SOPs, departmental coordination and patient experience initiatives."
  },
  {
    role: "Sport Physiotherapist",
    org: "Khel-Mahakumbh, Govt. of Gujarat",
    period: "2015",
    description:
      "Provided 10-day on-ground sport physiotherapy at Govt. Model School, Diyodar, during the state-level sporting event."
  },
  {
    role: "Physiotherapist",
    org: "Jalaram Charitable Trust, Patan",
    period: "Early Career",
    description:
      "Hands-on community physiotherapy practice — built the patient-first ethos that defines DianaMik today."
  }
];

export const education = [
  {
    degree: "LL.B. (Bachelor of Laws)",
    school: "Hemchandracharya North Gujarat University, Patan",
    period: "2019 — 2022"
  },
  {
    degree: "Masters of Hospital Management",
    school: "Hemchandracharya North Gujarat University, Patan",
    period: "2013 — 2015"
  },
  {
    degree: "Bachelor of Physiotherapy",
    school: "Maharaja Sayajirao University of Baroda",
    period: "2009 — 2013"
  }
];

export const certifications = [
  "NABH Implementation & Internal Auditor (Quality Council of India aligned)",
  "NABL Internal Auditor — ISO 15189",
  "VMove Pro — Global Public Health Contributor",
  "Workshop participation — Quality Council of India (QCI)"
];

export const projects = [
  {
    title: "Costing of Dialysis Department",
    type: "Healthcare Cost Study",
    summary:
      "Detailed unit-level costing of an in-hospital dialysis department to inform pricing, reimbursement strategy and capacity planning."
  },
  {
    title: "Hospital Staff Time-Use Study",
    type: "Operations Research",
    summary:
      "Time-and-motion study across clinical and support staff to identify inefficiencies and rationalise manpower utilisation."
  },
  {
    title: "NABH Compliance — MRD Files",
    type: "Quality Audit",
    summary:
      "Compliance and non-compliance assessment of Medical Record Department against NABH chapters — gap closure roadmap."
  },
  {
    title: "150+ NABH Accreditations Delivered",
    type: "Programme Outcome",
    summary:
      "Cumulative outcome across multispeciality, Ayush, Panchkarma facilities and imaging centres in Gujarat."
  }
];

export const testimonials = [
  {
    quote:
      "Dr. Barot's team made our NABH journey feel structured and achievable. The mock audits and SOP library saved us months of internal effort.",
    name: "Medical Superintendent",
    role: "Multispeciality Hospital, Ahmedabad"
  },
  {
    quote:
      "From layout planning to PMJAY empanelment, DianaMik handled everything end-to-end. Truly a one-stop hospital partner.",
    name: "Managing Director",
    role: "60-bed Hospital, North Gujarat"
  },
  {
    quote:
      "His blend of clinical insight and legal acumen is rare. Our medico-legal documentation has become genuinely defensible.",
    name: "Owner-Director",
    role: "Surgical Hospital, Surat"
  }
];

export const navLinks = [
  { label: "About", href: "#about" },
  { label: "Expertise", href: "#expertise" },
  { label: "Services", href: "#services" },
  { label: "Experience", href: "#experience" },
  { label: "Projects", href: "#projects" },
  { label: "Contact", href: "#contact" }
];
